(function (jQuery) {

    jQuery(document).ready(function () {

        jQuery('input[type=radio][name=reservation-type]').change(function () {
            var reservationType = jQuery(this).data('dynamic-row');

            jQuery('div.row[data-dynamic-row]').fadeOut(150).removeClass('dynamic-row-visible');
            jQuery('div.row[data-dynamic-row=' + reservationType + ']').delay(150).fadeIn(150).addClass('dynamic-row-visible');

            updateAccommodations();
            updateCampsiteRow();
        });

        jQuery('select[name=reservation-camping]').change(function () {
            updateAccommodations();
            updateCampsiteRow();
        });

        jQuery('input.reservation-submit').on('click', function (e) {
            var errorMessage = null;
            var submitId = jQuery(this).closest('form').attr('id');
            var formErrors = jQuery('div#form-errors');
            formErrors.empty();

            e.preventDefault();

            var errors = validateSection();

            if (jQuery.isEmptyObject(errors)) {
                jQuery('#' + submitId).submit();
            } else {
                errorMessage = '<div class="alert alert-danger"><ul>';

                jQuery.each(errors, function (i, v) {
                    errorMessage += '<li>' + v + '</li>';
                });

                errorMessage += '</ul></div>';

                formErrors.append(errorMessage);
            }
        });

    });

    function updateAccommodations() {
        jQuery('input[name=accommodation]').prop('checked', false).change();

        var accommodationId = jQuery('select[name=reservation-camping]').val();
        jQuery('div.accommodation-group').fadeOut(150).removeClass('accommodation-group-visible');
        jQuery('div.accommodation-group[data-accommodation-group=' + accommodationId + ']').delay(150).fadeIn(150).addClass('accommodation-group-visible');
    }

    function updateCampsiteRow() {
        jQuery('input[name=campsite-type]').prop('checked', false).change();
        jQuery('input[name=campsite-adults]').val('').change();
        jQuery('input[name=campsite-kids]').val('').change();
        jQuery('input[name=campsite-dog]').prop('checked', false).change();

        var campsiteId = jQuery('select[name=reservation-camping]').val();
        jQuery('div.campsite-group').fadeOut(150).removeClass('campsite-group-visible');
        jQuery('div.campsite-group[data-campsite-group=' + campsiteId + ']').delay(150).fadeIn(150).addClass('campsite-group-visible');
    }

    function validateSection() {
        function validateNumbers() {
            jQuery('input.validate-number').each(function () {
                if (jQuery(this).val() === '' || isNaN(jQuery(this).val())) {
                    var errorName = jQuery(this).data('error-name');
                    errors.push('Voer een geldig ' + errorName + ' in!');
                }
            });
        }

        function validateNotEmpty() {
            jQuery('input.validate-not-empty').each(function () {
                if (jQuery(this).val() === '') {
                    var errorName = jQuery(this).data('error-name');
                    errors.push('Voer een geldige ' + errorName + ' in!');
                }
            });
        }

        function validateEmails() {
            var testEmail = /^[A-Z0-9._%+-]+@([A-Z0-9-]+\.)+[A-Z]{2,4}$/i;
            jQuery('input.validate-email').each(function () {
                if (jQuery(this).val() === '' || !testEmail.test(jQuery(this).val())) {
                    errors.push('Voer een geldig e-mailadres in!');
                }
            });
        }

        var errors = [];

        // STAP 1
        if (jQuery('form#reservation-form-step-1').length) {
            if (!jQuery('input:radio[name=reservation-type]').is(':checked')) {
                errors.push('Selecteer een reserveringstype');
            }

            var checkbox = jQuery('input[name=reservation-type]:checked');

            // als gekozen is voor accommodatie
            if (checkbox.val() === 'Accommodatie') {
                if (!jQuery('input:radio[name=accommodation]').is(':checked')) {
                    errors.push('Selecteer een accommodatie');
                }
            } // als gekozen is voor kampeerplaats
            else if (checkbox.val() === 'Kampeerplaats') {
                if (!jQuery('input:radio[name=campsite-type]').is(':checked')) {
                    errors.push('Selecteer een type kampeerplaats');
                }

                validateNumbers();

                if (!jQuery('input:radio[name=campsite-dog]').is(':checked')) {
                    errors.push('Selecteer of u een hond meeneemt');
                }

            }

            validateNotEmpty();

        }

        // STAP 2
        if (jQuery('form#reservation-form-step-2').length) {
            if (!jQuery('input:radio[name=reservation-salutation]').is(':checked')) {
                errors.push('Kies een aanhef');
            }

            validateEmails();
            validateNotEmpty();
            validateNumbers();
        }

        return errors;
    }

})(jQuery);
